var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrading(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(50,50) scale(1.18) translate(-50,-50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,12 H65 A5,5 0 0 1 70,17 V47 A5,5 0 0 1 65,52 H15 A5,5 0 0 1 10,47 V17 A5,5 0 0 1 15,12 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,60 H50 M40,60 V52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,45 H55",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,45 V40 M33,45 V35 M42,45 V29 M51,45 V23",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,72 A16,16 0 1 0 90,72 A16,16 0 1 0 58,72 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,62 V82",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,67.5 C80.5,64.5 67.5,64.5 67.5,69.5 C67.5,73.5 80.5,72.5 80.5,77 C80.5,82 67.5,82 67.5,78.5",
    strokeWidth: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrading);
export default __webpack_public_path__ + "static/media/Trading.6f89a0a2a2bf00ddfacda909d61c78b8.svg";
export { ForwardRef as ReactComponent };